module.exports = __webpack_public_path__ + "img/tires.0f6eeb30.jpeg";